<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Type</p>
    </div>
    <div class="field">
      <b-select v-model="proposableLc"
                :disabled="!address"
                expanded>
        <option value="" key="tout">Toutes</option>
        <option value="1" key="ProposableLc">Proposable LC</option>
        <option value="0" key="NonProposableLc">Non-proposable LC</option>
      </b-select>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'proposable-lc',
  data() {
    return {
    };
  },
  watch: {
    proposableLc() {
      this.valid = true;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.rechargementFaces({
        valid: this.valid,
        panneauxLcPanier: this.panneauxLcPanier,
        codeFace: '',
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur au niveau des proposables LC', e);
      });
    },
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      address: 'address',
      filtresDynamiques: 'filtresDynamiques',
      getProposableLc: 'proposableLc',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    proposableLc: {
      get() {
        return this.getProposableLc;
      },
      set(value) {
        this.setProposableLc(value);
      },
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setProposableLc: types.SET_PROPOSABLE_LC,
    }),
    ...VenteFacesLc.mapActions({
      rechargementFaces: 'gestionPanneauxLC',
    }),
  },
};
</script>
<style scoped>
  select {
    padding-left:10px;
    padding-right: 10px;
    -webkit-appearance: none;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    color:#5E738B;
  }

  select:disabled{
    background-color: rgba(200, 200, 200, 0.2);
    border:none;
  }

  select:hover{
    border-color: #bfbfbf;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/proposableLc.vue